import React from "react";
import arrowSimpleRight from "../../assets/icons/arrow-simple-right.svg";
import spotGroupIcon from "../../assets/icons/spot-group.svg";
import PropTypes from "prop-types";
import standIcon from "../../assets/icons/stand.svg";
import BookingBookableProfileLinks from "../BookingBookableProfileLinks/BookingBookableProfileLinks";
import BookingActions from "../BookingActions/BookingActions";
import useFunction from "../../hooks/useFunction";
import useBooking from "../../hooks/useBooking";
import usePrice from "../../hooks/usePrice";
import bookingPaymentTimingEnum from "../../data/bookingPaymentTimingEnum";
// import "./style.scss";

const BookingItemDetail = ({booking, callbackConfirm, showForAdmin = false}) => {
  const {date, dateTime} = useFunction();
  const {getBookingStatusLabel, getBookingActionLabel, getBookingStatusIcon} = useBooking();
  const {formatPrice, transactionFee} = usePrice();

  const getClassname = () => {
    let className = "component-booking-item-detail booking-status-" + booking.status;
    if (booking.needs_action) className += " needs-action";
    return className;
  };

  return (
    <div className={getClassname()}>
      <div className="header">
        <div className="title">
          <h1><img src={getBookingStatusIcon(booking)} alt="status"/>
            {getBookingStatusLabel(booking.status)}
            {booking.updated_after_request_at && booking.status === "requested" && (
              <span className="meta"> (geupdate)</span>
            )} - {booking.status === "concept" && <>Nog af te maken</>}
            {(booking.status === "requested" || booking.status === "accepted") &&
              (booking.needs_action ? getBookingActionLabel(booking.needs_action) : "Wachten op tegenpartij")}
            {booking.status === "pay-after" && <>Gepland! {booking.active_user_pays && 'achteraf betalen'}</>}
            {booking.status === "paid" && <>Gepland!</>}
          </h1>
        </div>

        <div className="actions">
          <BookingActions booking={booking} callbackConfirm={callbackConfirm} hideNegativeButtons={true}/>
        </div>
      </div>

      <div className="row field-id">
        <p>Boeking nummer: #{booking.booking_number}</p>
      </div>

      <div className="blocks">
        <div className="block bookables">
          <BookingBookableProfileLinks
            booking={booking}
            buttonSize={"s"}
          />
        </div>
        <div className="block finance">
          {booking.status !== "concept" && (
            <>
              {((booking.direction === "receiving" && booking.prices) || showForAdmin) && (
                <div className="field price">
                  <p className="label">
                    {booking.prices.totals.receiving.total.get ? "Inkomsten: " : "Uitgaven: "}
                    {showForAdmin && booking.received_by_company?.legal_name}
                  </p>
                  {booking.prices.totals.receiving.get.rent ? (
                    <p className="price-line">Verhuur
                      inkomsten: {formatPrice(booking.prices.totals.receiving.get.rent)}</p>
                  ) : (
                    <p className="price-line">Huur kosten: {formatPrice(booking.prices.totals.receiving.pay.rent)}</p>
                  )}
                  <p className="price-line">Opties
                    inkomsten: {formatPrice(booking.prices.totals.receiving.get.options)}</p>
                  {booking.prices.totals.receiving.total.get ? (
                    <p className="price-line"><strong>Totale inkomsten (ex.
                      BTW): {formatPrice(booking.prices.totals.receiving.total.get)}</strong></p>
                  ) : (
                    <p className="price-line"><strong>Totale uitgaven (ex.
                      BTW): {formatPrice(booking.prices.totals.receiving.total.pay)}</strong></p>
                  )}
                </div>
              )}
              {((booking.direction === "requesting" && booking.prices) || showForAdmin) && (
                <div className="field price">
                  <p className="label">
                    {booking.prices.totals.requesting.total.get ? "Inkomsten: " : "Uitgaven: "}
                    {showForAdmin && booking.requested_by_company?.legal_name}
                  </p>
                  {booking.prices.totals.requesting.get.rent ? (
                    <p className="price-line">Verhuur
                      inkomsten: {formatPrice(booking.prices.totals.requesting.get.rent)}</p>
                  ) : (
                    <p className="price-line">Huur kosten: {formatPrice(booking.prices.totals.requesting.pay.rent)}</p>
                  )}
                  <p className="price-line">Opties
                    kosten: {formatPrice(booking.prices.totals.requesting.pay.options)}</p>
                  <p className="price-line">
                    {(booking.prices.totals.requesting.pay.fees >= transactionFee
                      ? "Boekingskosten:"
                      : "Fee & Boekingskosten:") + " "}
                    {formatPrice(booking.prices.totals.requesting.pay.fees)}
                  </p>
                  {booking.prices.totals.requesting.total.get ? (
                    <p className="price-line"><strong>Totale inkomsten (ex.
                      BTW): {formatPrice(booking.prices.totals.requesting.total.get)}</strong></p>
                  ) : (
                    <p className="price-line"><strong>Totale uitgaven (ex.
                      BTW): {formatPrice(booking.prices.totals.requesting.total.pay)}</strong></p>
                  )}
                </div>
              )}
            </>
          )}

          {(booking.status === "concept" || booking.status === "requested" || booking.status === "accepted" || booking.status === "pay-after") &&
            <p><strong>Betaalmoment: {bookingPaymentTimingEnum.getLabel(booking.payment_timing)}</strong></p>
          }

        </div>
        <div className="block meta">
          <p className="label">Aangevraagd:</p>
          <p className="date">{dateTime(booking.created_at)}</p>
          {booking.updated_at !== null && booking.updated_at !== booking.created_at &&
            <>
              <p className="label">Geupdate:</p>
              <p className="date">{dateTime(booking.updated_at)}</p>
            </>
          }
        </div>
        <div className="block dates">
          <p className="label">Data:</p>
          {booking.date_ranges?.map((range, i) => (
            <div key={i}>
              <p className="date">
                {range.end_date ? (
                  <>
                    {date(range.start_date)} <span className="meta">t/m</span> {date(range.end_date)}
                  </>
                ) : (
                  date(range.start_date)
                )}
              </p>
            </div>
          ))}
        </div>
        <div className="block spots">
          {booking.spot_group && <>
            {booking.spot_group.show_spots_as_list &&
              <>
                <p className="label">Geboekte meters:</p>
                <p>{booking.spots.length} x {booking.spot_group.spots_in_list_length} = {booking.spots.length * booking.spot_group.spots_in_list_length} meter</p>
              </>
            }
          </>
          }

          {(!booking.spot_group || (booking.spot_group && !booking.spot_group.show_spots_as_list)) &&
            <>
              <p className="label">Spots:</p>
              {booking.spots?.length > 0 && (
                <div className="spots-container">
                  {booking.spots.map((spot, i) =>
                    spot.spot_cluster ? (
                      <div key={i} className="spot">{spot.spot_cluster.label}: {spot.label}</div>
                    ) : (
                      <div key={i} className="spot">{spot.label}</div>
                    )
                  )}
                </div>
              )}
            </>
          }
        </div>
        <div className="block direction">
          <p className="label">Richting:</p>
          <p>{booking.direction === "receiving" ? "Inkomend" : "Uitgaand"}</p>
          {(booking.type === "spot-group-requests-stand" || booking.type === "stand-requests-spot") && (
            <div className="row icons">
              {booking.type === "spot-group-requests-stand" ? (
                <>
                  <img width={22} src={spotGroupIcon} alt="Locatie"/>
                  <img width={22} src={arrowSimpleRight} alt="->"/>
                  <img width={22} src={standIcon} alt="Stand / Truck"/>
                </>
              ) : (
                <>
                  <img width={22} src={standIcon} alt="Stand / Truck"/>
                  <img width={22} src={arrowSimpleRight} alt="->"/>
                  <img width={22} src={spotGroupIcon} alt="Locatie"/>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <hr/>

      {booking.booking_options?.length > 0 && (
        <div className="options">
          <p className="label">Opties:</p>
          {booking.booking_options.map((option, i) => (
            <div key={i}>
              <p>{option.bookable_option.label}</p>
            </div>
          ))}
        </div>
      )}

      <br/>
      <br/>
      <hr/>

      <div className="actions">
        <BookingActions booking={booking} callbackConfirm={callbackConfirm} hideNegativeButtons={false}/>
      </div>

      {(booking.deny_reason_requested_company || booking.deny_reason_received_company) && (
        <div className="deny-reasons">
          <p className="label">Opgegeven reden tot afwijzing:</p>
          <p>{booking.deny_reason_requested_company}</p>
          <p>{booking.deny_reason_received_company}</p>
        </div>
      )}

    </div>
  );
};

BookingItemDetail.propTypes = {
  booking: PropTypes.object.isRequired,
  callbackConfirm: PropTypes.func.isRequired,
  showForAdmin: PropTypes.bool,
};

export default BookingItemDetail;
